import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchMarketplaceAccessDenialsArgs } from '../api/types/marketplaceAccess.types';

import { fetchMarketplaceAccessDenials } from '../api/marketplaceAccess.api';

export const marketplaceAccessQueryKeys = createQueryKeys('marketplaceAccess', {
  fetchDenials: ({
    activeOnly,
    limit,
    offset,
  }: FetchMarketplaceAccessDenialsArgs) => ({
    queryFn: () => fetchMarketplaceAccessDenials({ activeOnly, limit, offset }),
    queryKey: [activeOnly, offset, limit],
  }),
});
